import { Injectable } from '@angular/core';
import { CachingApiService } from './cachingApiService';
import { TripDesignation } from './commonInterfaces';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { SessionStorageService } from '../storage/session-storage.service';
import { Observable, of, switchMap } from 'rxjs';
import { BroadcastService } from '../services/broadcast.service';

@Injectable({
  providedIn: 'root'
})
export class TripDesignationService extends CachingApiService<TripDesignation[]>{
  protected broadcastKey: string = "trip-designations"
  override getApiUrl(): string {
    return `${this.config.dataApiUrl}/trip-designations`
  }

  constructor(
     http: HttpClient,
     config: ConfigService,
     storage: SessionStorageService,
     broadcastService: BroadcastService
  ) {
    super(http, config, storage, broadcastService)
   }

   getDesignations(): Observable<TripDesignation[]> {
    return this.getCache().pipe(
      switchMap(cache => of(cache.data))
    )
   }

   getPpmDesignation(): Observable<TripDesignation | undefined> {
    return this.getCache().pipe(
      switchMap(cache => of(cache.data.find(d => d.id === 1)))
    )
   }
}
